import { CartItemDto } from "@/types/dto/cart-item-dto";
import { atom } from "recoil";

export interface CreateOrderState {
  ordererBusinessName: string; // 공급자 정보
  ordererPhone: string;
  ordererName: string; // 고객명
  ordererMail: string;
  constructionName: string;
  constructionWorkName: string;
  receiverName: string;
  receiverPhone: string;
  receiverEmailId: string;
  receiverEmailDomain: string;
  receiverRoad: string;
  receiverJibun: string;
  receiverAddressDetail: string;
  receiverPostalCode: string;
  receiverMemo: string;
  items: CartItemDto[];
}

export const createOrderState = atom<CreateOrderState>({
  key: "createOrderState",
  default: {
    ordererBusinessName: "",
    ordererPhone: "",
    ordererMail: "",
    ordererName: "",
    constructionName: "",
    constructionWorkName: "",
    receiverName: "",
    receiverPhone: "",
    receiverEmailId: "",
    receiverEmailDomain: "",
    receiverRoad: "",
    receiverJibun: "",
    receiverAddressDetail: "",
    receiverPostalCode: "",
    receiverMemo: "",
    items: [],
  },
});
